import { useTranslation } from 'react-i18next';
import { useMeta } from '../../api/hooks/useMeta';

// Customers see both invoice statuses with the same meta text, super admin needs to tell them apart
export function usePaymentStatusLabel(): (paymentStatus: PaymentStatus) => string {
	const { t } = useTranslation();
	const { meta } = useMeta('ordersService');

	return (paymentStatus: PaymentStatus): string => {
		switch (paymentStatus) {
			case 'awaitingInvoiceCreation':
				return t('general.superadmin_awaiting_invoice_creation');
			case 'awaitingInvoiceAcceptance':
				return t('general.superadmin_awaiting_invoice_acceptance');
			default:
				return (meta?.paymentStatus?.[paymentStatus] as string) || t('general.unknown');
		}
	};
}
